import { gql } from '@apollo/client';

const SearchResultFragment = gql`
  fragment SearchResultFragment on SearchResultInterface {
    category
    ... on AcademyArticleSearchResult {
      article {
        id
        slug
        title
        author {
          name
        }

        # extended info
        previewImage {
          url
        }
      }
    }
    ... on CompanySearchResult {
      company {
        id
        slug
        name
        investmentRound
        logoUrl

        # extended info
        employeeCount
        shortDescription
        location {
          name
        }
        overallRating
      }
    }
    ... on PortfolioUserSearchResult {
      portfolioUser {
        id: slug
        slug
        avatarUrl
        lastname
        firstname
        currentCompany {
          name
        }
        currentPosition

        # extended info
        city {
          name
          stateCode
        }
      }
    }
    ... on WarRoomPostSearchResult {
      comments {
        record {
          id
          author {
            ... on Anonymous {
              username
              warRoomAvatarUrl
            }
            ... on Public {
              firstname
              lastname
              avatarUrl
            }
          }

          # extended info
          createdAt
        }
        highlightedText {
          text
          highlightTo
          highlightFrom
        }
      }
      post {
        id
        slug
        content {
          ... on DealStory {
            title

            # extended info
            rawText
          }
          ... on Link {
            title

            # extended info
            rawText
          }
          ... on LinkedinPost {
            title

            # extended info
            rawText
          }
          ... on Story {
            title

            # extended info
            rawText
          }
          ... on YoutubeLink {
            title

            # extended info
            rawText
          }
        }
        author {
          ... on Anonymous {
            username
          }
          ... on Public {
            firstname
            lastname
          }
        }

        # extended info
        viewed
        category
        commentsCount
        topics {
          id
          name
          emoji
          slug
        }
      }
    }
    ... on WarRoomUserSearchResult {
      warRoomUser {
        id: username
        username
        avatarUrl

        # extended info
        warRoomPosition
        warRoomDescription
      }
    }
    ... on CompanyPagesCatalogSearchResult {
      page {
        id
        title
        pageType
        company {
          slug
          logoUrl
        }
        roleCategory {
          slug
        }
        customerSegment {
          slug
        }
        region {
          slug
        }
      }
    }
  }
`;

export default SearchResultFragment;
